import React, { useMemo } from 'react';

import { getProviderDetailsAction } from 'domain/paySettings/actions';

import useDispatchAction from 'hooks/useDispatchAction';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import AccountDetails from './components/AccountDetails';
import WalletBalances from './components/WalletBalances';

interface DetailsTabProps {
  id: string;
  isAvailableWallets: boolean;
}

const DetailsTab: React.FC<DetailsTabProps> = ({ id, isAvailableWallets }) => {
  const payload = useMemo(() => ({ id }), [id]);

  const { data, isLoading } = useDispatchAction(getProviderDetailsAction, payload);

  return (
    <Stack direction="row" spacing={3} height="100%">
      <Box component={Paper} p={3} minWidth={400}>
        <AccountDetails data={data} isLoading={isLoading} />
        {isAvailableWallets && <WalletBalances id={id} />}
      </Box>

      <Box sx={{ flexGrow: 2, my: '24px !important' }}>
        <Stack component={Paper} height="100%" justifyContent="center" alignItems="center">
          NO TRANSACTIONS YET
        </Stack>
      </Box>
    </Stack>
  );
};

export default DetailsTab;
